import { DefaultBaseObjectFormChangeDetector } from './default-base-object-form-change-detector';
import { WaterSourceImport } from '../_models/_unit-operations/utilties/water-source-import';

export class WaterSourceImportFormChangeDetector extends DefaultBaseObjectFormChangeDetector {
  override detectChangesInValues(originalFormValue: any, currentValue: any): boolean {
    let changes = super.detectChangesInValues(originalFormValue, currentValue);
    const sourceStreamOriginal = originalFormValue as WaterSourceImport;
    const sourceStreamCurrent = currentValue as WaterSourceImport;

    if (
      sourceStreamCurrent.inletSourceInformationStreams.length !=
      sourceStreamOriginal.inletSourceInformationStreams.length
    ) {
      changes = changes || true;
    }

    return changes;
  }
}
